module.exports = __webpack_public_path__ + "static/product_management_card-f2ad89e96caba1f1ed35b4c3cb2369f3.png";